export default "__VITE_ASSET__OSAHbGQ___"